function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.5338 0H42.0156V82.9407H47.5338V0Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5594 0H30.8008V82.9407H33.5594V0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.3576 0H61.5977V82.9407H64.3576V0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7501 0H55.9902V82.9407H58.7501V0Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2166 0H8.36816V82.9407H11.2166V0Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5828 0H16.8232V82.9407H19.5828V0Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.60801 0H0V83H5.60801V0Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9659 0H67.2061V82.9407H69.9659V0Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M128.717 0H123.109V82.9407H128.717V0Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M145.54 0H137.173V82.9407H145.54V0Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M151.148 0H148.3V82.9407H151.148V0Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M159.515 0H153.907V83H159.515V0Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M109.133 0H103.525V82.9407H109.133V0Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M120.349 0H114.741V82.9407H120.349V0Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M97.9173 0H92.3096V82.9407H97.9173V0Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M83.9417 0H78.333V82.9407H83.9417V0Z"
});

function SvgBarcodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 83,
    viewBox: "0 0 160 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIcon);
export default __webpack_public_path__ + "static/media/barcode_icon.90f438ba.svg";
export { ForwardRef as ReactComponent };